import React from "react";
import _ from "lodash";

const DashboardSmallCard = ({
  title,
  para,
  button,
  buttonStatus = false,
  buttonname,
  onClick,
}) => {
  return (
    <div  className="p-4 rounded-xl  relative w-full h-full bg-slate-100 px-6 shadow-md">
      <h2 className="text-2xl font-semibold text-deep-grey">{_.capitalize(title)}</h2>
      <p className="text-6xl my-2 text-forging-yellow font-semibold ">{para}</p>
      {buttonStatus && (
        <div className="absolute bottom-4 right-4">
          <button
            onClick={onClick}
            className="bg-sport-yellow py-2 px-4 rounded-lg text-md font-semibold"
          >
            {buttonname}
          </button>
        </div>
      )}
    </div>
  );
};

export default DashboardSmallCard;
